import { css } from "emotion";
import ContentBlock from "../../../../components/layout/ContentBlock";
import H3 from "../../../../components/global/H3";
import FlexColumn from "./FlexColumn";
import FlexRow from "./FlexRow";
import { max } from "../../../../utils/CssUtils";

const wrapper = css({
  padding: "0 15px",
  [max(600)]: {
    width: "100%",
    div: {
      width: "100%"
    }
  }
});

const deliveryPartnersStyles = css({
  [max(600)]: {
    flexDirection: "column"
  },
  p: {
    overflowWrap: "break-word",
    wordWrap: "break-word",
    maxWidth: 480
  }
});

const deliveryPartnersTextStyles = css({
  flexShrink: 2,
  marginRight: "20px !important",
  [max(600)]: {
    margin: "0px auto 10px auto !important"
  }
});

const hrStyles = css({
  margin: "72px auto",
  border: "0.75px solid #dedede",
  [max(600)]: {
    maxWidth: "100%",
    width: "100%",
    margin: "40px auto"
  }
});

const h3Styles = {
  textAlign: "center",
  marginBottom: 48,
  [max(600)]: {
    marginBottom: 12
  }
};

const ProjectDeliveryPartners = ({
  children // Should pass in just the text, Flag, Quote as components
}) => {
  if (children[1]) {
    Object.assign(children[1].props, {
      // Assign some props (styles) to the Flag component
      width: 480,
      height: 120,
      textPadding: "16px 16px 16px 4px"
    });
  }

  return (
    <ContentBlock color="grey">
      <div className={wrapper}>
        <H3 style={h3Styles}>Project delivery partners</H3>
        <FlexColumn>
          <FlexRow className={deliveryPartnersStyles}>
            <div className={deliveryPartnersTextStyles}>
              {children[0]}
              {/* Pass in the text as <P> tag */}
            </div>
            {children[1]}
            {/* Pass in the Flag component being used */}
          </FlexRow>
        </FlexColumn>

        {children[2] ? <hr className={hrStyles} /> : undefined}

        {children[2]}
        {/* Pass in the Quote component */}
      </div>
    </ContentBlock>
  );
};

export default ProjectDeliveryPartners;
